import React from "react";
import CardLayout from "../../common/cardLayout/CardLayout";
import "./ResourcesStyles.css";
import image from "../../../assets/images/rafiki.png";
import callIcon from "../../../assets/images/profileC.svg";
import mailIcon from "../../../assets/images/profileM.svg";
const MaterialPill = ({ text, link = "" }) => {
  return (
    <div className="material-pill mb-3">
      <label>{text}</label>
      <div className="d-flex" style={{ gap: "10px" }}>
        <button style={{ borderRadius: "8px" }} className="btn primary-btn">
          View
        </button>
        <button style={{ borderRadius: "8px" }} className="btn primary-btn">
          Download
        </button>
      </div>
    </div>
  );
};

const QuickHelp = () => {
  return (
    <CardLayout>
      <div className="container-fluid d-flex justify-content-start w-100 py-3">
        <h5 className="muted-text">Quick Help</h5>
      </div>
      <div className=" container-flex justify-content">
        <div className="row boxlayout">
          <div className="col-sm-4">
            <img src={image}></img>
          </div>
          <div className=" col-sm-6 ">
            <strong style={{ color: "#1E293B" }}>
              <label>Contact Us</label>
            </strong>
            <div className="row">
              <div className="col-sm-3 py-2">
                <img src={mailIcon}></img>
              </div>
              <div className="col-sm-3 py-3">
                <strong style={{ color: "#1E293B" }}>
                  <a href="">rose.help@precisebh.com</a>
                </strong>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3 py-2">
                <img src={callIcon}></img>
              </div>
              <div className="col-sm-8 py-3">
                <a href="">833-400-7673</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CardLayout>
  );
};

export default QuickHelp;
